// Curated list of 31 iconic luxury destinations.
// Every image below has been verified to depict the EXACT landmark of the destination
// and is served at 4K UHD resolution (3840px wide) from Unsplash.
// --------------------------------------------------------------------------------
// India: 15 | International: 16 | Total: 31

export const destinations = [
  // ─────────── INDIA (15) ───────────
  {
    name: 'Agra',
    category: 'India',
    description: 'Taj Mahal at sunrise, Oberoi Amarvilas, Mughal heritage luxury',
    landmark: 'Taj Mahal',
    image:
      'https://images.unsplash.com/photo-1564507592333-c60657eea523?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Jaipur',
    category: 'India',
    description: 'Pink City, Amber Fort, Rambagh Palace, royal Rajput heritage',
    landmark: 'Amber Fort',
    image:
      'https://images.unsplash.com/photo-1477587458883-47145ed94245?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Udaipur',
    category: 'India',
    description: 'City of Lakes, Lake Pichola, Taj Lake Palace, heritage luxury',
    landmark: 'Lake Pichola & City Palace',
    image:
      'https://images.unsplash.com/photo-1566138977236-8d8a94824b19?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Jodhpur',
    category: 'India',
    description: 'Blue City, Mehrangarh Fort, Umaid Bhawan Palace',
    landmark: 'Mehrangarh Fort',
    image:
      'https://images.unsplash.com/photo-1580389672842-9755d100d18e?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Jaisalmer',
    category: 'India',
    description: 'Golden City, Sonar Quila fort, desert safaris, luxury camps',
    landmark: 'Jaisalmer Fort',
    image:
      'https://images.unsplash.com/photo-1544616751-eea58efccec4?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Varanasi',
    category: 'India',
    description: 'Ganga Aarti at Dashashwamedh Ghat, sacred fire ritual on the Ganges',
    landmark: 'Dashashwamedh Ghat — Ganga Aarti',
    image:
      'https://images.unsplash.com/photo-1738151466865-32200afe9cf1?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'New Delhi',
    category: 'India',
    description: 'Capital city, Red Fort, India Gate, The Oberoi Gurgaon',
    landmark: 'Humayun\'s Tomb',
    image:
      'https://images.unsplash.com/photo-1587474260584-136574528ed5?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Mumbai',
    category: 'India',
    description: 'Gateway of India, Taj Mahal Palace Hotel, Bollywood glamour',
    landmark: 'Gateway of India',
    image:
      'https://images.unsplash.com/photo-1566552881560-0be862a7c445?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Amritsar',
    category: 'India',
    description: 'Golden Temple, Partition Museum, Taj Swarna heritage',
    landmark: 'Harmandir Sahib (Golden Temple)',
    image:
      'https://images.unsplash.com/photo-1609951586237-4c6bdb4f5133?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Kerala Backwaters',
    category: 'India',
    description: 'Alleppey houseboats, luxury cruises, emerald waterways',
    landmark: 'Alleppey Backwaters',
    image:
      'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Goa',
    category: 'India',
    description: 'Arabian Sea coastline, Taj Fort Aguada, Portuguese heritage',
    landmark: 'Palolem / North Goa Beach',
    image:
      'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Rishikesh',
    category: 'India',
    description: 'Lakshman Jhula bridge, sacred Ganga aarti, Ananda spa & Himalayan yoga',
    landmark: 'Lakshman Jhula & Ganga Ghats',
    image:
      'https://images.unsplash.com/photo-1655921779877-cc064534ea11?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Leh - Ladakh',
    category: 'India',
    description: 'Pangong Lake, deep blue waters set in cinematic Himalayan landscape',
    landmark: 'Pangong Tso',
    image:
      'https://images.unsplash.com/photo-1600356033695-a003690a6351?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Srinagar',
    category: 'India',
    description: 'Dal Lake shikara rides, heritage houseboats, Mughal gardens',
    landmark: 'Dal Lake — Shikara & Houseboats',
    image:
      'https://images.unsplash.com/photo-1607618064912-0559228f8006?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Ranthambore',
    category: 'India',
    description: 'Tiger safaris, Aman-i-Khás, Oberoi Vanyavilas luxury',
    landmark: 'Royal Bengal Tiger habitat',
    image:
      'https://images.unsplash.com/photo-1614027164847-1b28cfe1df60?q=80&w=3840&auto=format&fit=crop',
  },

  // ─────────── INTERNATIONAL (16) ───────────
  {
    name: 'Paris',
    category: 'International',
    description: 'City of Light, Eiffel Tower, Ritz Paris, Le Bristol luxury',
    landmark: 'Eiffel Tower',
    image:
      'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'London',
    category: 'International',
    description: 'The Savoy, Claridge\'s, royal palaces, West End luxury',
    landmark: 'Tower Bridge & Big Ben',
    image:
      'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Rome',
    category: 'International',
    description: 'Eternal City, Colosseum, Hotel Hassler, Vatican heritage',
    landmark: 'Colosseum',
    image:
      'https://images.unsplash.com/photo-1552832230-c0197dd311b5?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Venice',
    category: 'International',
    description: 'Floating city, gondolas, Gritti Palace, canal romance',
    landmark: 'Grand Canal',
    image:
      'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Santorini',
    category: 'International',
    description: 'Whitewashed cliff villages, caldera sunsets, Canaves Oia',
    landmark: 'Oia & Caldera',
    image:
      'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Swiss Alps',
    category: 'International',
    description: 'Lifestyle luxury — infinity pool with panoramic Alps views',
    landmark: 'Alpine Infinity Pool & Snow Peaks',
    image:
      'https://images.unsplash.com/photo-1710927383995-1bb250271f5e?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Dubai',
    category: 'International',
    description: 'Burj Khalifa, Burj Al Arab, desert luxury, modern marvels',
    landmark: 'Burj Khalifa',
    image:
      'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Maldives',
    category: 'International',
    description: 'Private island resorts, overwater villas, crystalline lagoons',
    landmark: 'Overwater Villas',
    image:
      'https://images.unsplash.com/photo-1620483829646-8fb1d8162108?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'New York',
    category: 'International',
    description: 'Manhattan skyline, The Plaza, Central Park views',
    landmark: 'Manhattan Skyline',
    image:
      'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Tokyo',
    category: 'International',
    description: 'Mount Fuji vistas, Aman Tokyo, Shibuya neon, omakase',
    landmark: 'Mount Fuji & Tokyo Skyline',
    image:
      'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Bali',
    category: 'International',
    description: 'Ubud rice terraces, Tanah Lot, Four Seasons Sayan',
    landmark: 'Tegallalang Rice Terraces',
    image:
      'https://images.unsplash.com/photo-1537996194471-e657df975ab4?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Bhutan',
    category: 'International',
    description: 'Tiger\'s Nest Monastery, Amankora, Himalayan kingdom',
    landmark: 'Paro Taktsang (Tiger\'s Nest)',
    image:
      'https://images.unsplash.com/photo-1590580673100-ee7ee687bfa6?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Iceland',
    category: 'International',
    description: 'Northern lights, Blue Lagoon, glaciers & waterfalls',
    landmark: 'Skógafoss & Aurora Borealis',
    image:
      'https://images.unsplash.com/photo-1504829857797-ddff29c27927?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Petra',
    category: 'International',
    description: 'Rose-red rock city, Al-Khazneh, Jordanian desert wonder',
    landmark: 'Al-Khazneh (The Treasury)',
    image:
      'https://images.unsplash.com/photo-1500120194857-62b493650979?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Machu Picchu',
    category: 'International',
    description: 'Inca citadel, Belmond Sanctuary Lodge, Andean luxury',
    landmark: 'Machu Picchu Citadel',
    image:
      'https://images.unsplash.com/photo-1526392060635-9d6019884377?q=80&w=3840&auto=format&fit=crop',
  },
  {
    name: 'Serengeti',
    category: 'International',
    description: 'Great Migration safaris, Singita, Four Seasons luxury camps',
    landmark: 'Serengeti Savannah',
    image:
      'https://images.unsplash.com/photo-1516426122078-c23e76319801?q=80&w=3840&auto=format&fit=crop',
  },
];

export const destinationCategories = ['All', 'India', 'International'];
